var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSuccessTickRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "#DCFCE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1516 44.5C65.9508 48.4223 65.3812 52.5 63.5378 56.0531C61.6944 59.6063 58.6886 62.4201 55.0217 64.0253C51.3548 65.6305 47.2484 65.9301 43.3873 64.8741C39.5263 63.8182 36.1439 61.4704 33.8043 58.2225C31.4647 54.9745 30.3093 51.0226 30.5307 47.0259C30.7522 43.0292 32.3371 39.2291 35.0212 36.2595C37.7053 33.2899 41.3263 31.3302 45.2804 30.7073C49.2345 30.0843 53.2827 30.8357 56.7498 32.8362",
    stroke: "#00C950",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 46.25L48 51.5L65.5 34",
    stroke: "#00C950",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccessTickRound);
export default __webpack_public_path__ + "static/media/ic_success_tick_round.c9e559f21237ca68096a61818aeb020d.svg";
export { ForwardRef as ReactComponent };